"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultColors = ['#00A2DF',
// primary
'#6B8A99',
// robustBlue2
'#17BC65',
// futureGreen3
'#F2BE24',
// yellow3
'#C6AEE5', '#DA40E2', '#5E66F9'];
var _default = exports["default"] = defaultColors;
//# sourceMappingURL=defaultColors.js.map